//获取域名
var host = window.location.host;
if (host == "localhost:8080") {
  var customerId = 111141; //111141
} else {
  var customerId = 111141; //111141
}

const CHANG_AN_ID = customerId; //111141
// const PEOPLE_ID = 111152; // 人民网

if (host == "localhost:8080") {
  var PEOPLE_ID = 111112; // 人民网
} else {
  var PEOPLE_ID = 111152; // 人民网
}

export default {
  CHANG_AN_ID,
  PEOPLE_ID,
};



// WEBPACK FOOTER //
// ./src/constants/customerId.constant.js